module.exports = __webpack_public_path__ + "static/img/2.368e603b.png";